/** The window presets every time-spanning chart offers, narrowest first. `0` is all time. */
export const dateRangeOptions = [
  { value: 7, label: 'Statistic_LastWeek' },
  { value: 30, label: 'Statistic_LastMonth' },
  { value: 90, label: 'Statistic_LastQuarter' },
  { value: 365, label: 'Statistic_LastYear' },
  { value: 0, label: 'Statistic_AllTime' },
] as const;

export type DateRangePreset = typeof dateRangeOptions[number]['value'];

/** Start of the window a preset covers. All time reaches back to the epoch. */
export const rangeStartFor = (preset: DateRangePreset): Date => {
  if (preset === 0) return new Date(0);

  const start = new Date();
  start.setDate(start.getDate() - preset);
  start.setHours(0, 0, 0, 0);

  return start;
};

/** All time always qualifies: it is the catch-all the other presets fall back to. */
export const presetHasData = (dates: Date[], preset: DateRangePreset): boolean =>
  preset === 0 || dates.some(date => date >= rangeStartFor(preset));

/**
 * The narrowest preset that still holds data, widening until something is in range and
 * ending at all time. A fixed default cannot do this: pick a week and a project last
 * touched in spring opens empty, pick all time and an active one opens zoomed out.
 */
export const narrowestRangeWithData = (dates: Date[]): DateRangePreset =>
  dateRangeOptions.find(({ value }) => value !== 0 && presetHasData(dates, value))?.value ?? 0;
